<template>
  <div>
    <v-card class="assessment-light" flat>
      <v-container>
        <v-row align="center" no-gutters>
          <v-col cols="5">
            <v-text-field reverse id="systolic" v-model="systolic" :rules="[validate]"
              :label="$t('questions.blood_pressure.input_label.systolic')" :placeholder="placeholder"
              :min="options.systolic && options.systolic.min" :max="options.systolic && options.systolic.max"
              :suffix="$t('units.mmHg.short')" @input="update"
              autocomplete="off" :persistent-placeholder="shouldPersistPlaceholder"
              class="custom-placeholder"></v-text-field>
          </v-col>
          <v-col cols="2">
            <p class="text-center display-2 primaryblue--text">/</p>
          </v-col>
          <v-col cols="5">
            <v-text-field id="diastolic" v-model="diastolic" :rules="[validate]"
              :label="$t('questions.blood_pressure.input_label.diastolic')" :placeholder="placeholder"
              :min="options.diastolic && options.diastolic.min" :max="options.diastolic && options.diastolic.max"
              :suffix="$t('units.mmHg.short')" @input="update"
              autocomplete="off" :persistent-placeholder="shouldPersistPlaceholder"
              class="custom-placeholder"></v-text-field>
          </v-col>

        </v-row>
      </v-container>

      <v-card-actions class="justify-center" v-if="!options.hideSkipButton">
        <unknown-button id="blood-pressure-unknown" @click="setUnknown"></unknown-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import languageLogic from '@/mixins/languageLogic'
import rateRanges from '@/mixins/rateRanges'
import ui from '@/mixins/ui'
import { mapActions } from 'vuex'
import UnknownButton from '@/components/widgets/UnknownButton.vue'

export default {
  name: 'bloodpressure',
  components: { UnknownButton },
  mixins: [languageLogic, rateRanges, ui],
  model: {
    prop: 'items',
    event: 'click'
  },
  data() {
    return {
      systolic: null,
      diastolic: null,
      validate: value => this.valid(value) || this.$i18n.t('questions.blood_pressure.error'),
      valid: value => (/^[1-9]\d*$/.test(value) || this.items[0].unknown)
    }
  },
  props: {
    'options': Object,
    'items': Array,
    'panelName': String
  },
  computed: {
    autoProgress() {
      return this.$store.state.settings.engagements_features.autoProgress
    },
    shouldPersistPlaceholder() {
      return this.items[0].unknown;
    },
    placeholder() {
      return this.items[0].unknown ? this.$i18n.t('app.inputs.unknown.display') : null
    }
  },
  methods: {
    setUnknown() {
      this.systolic = null
      this.diastolic = null
      this.items[0].selected = true
      this.items[0].value = null
      this.items[0].unknown = true
      this.clearRangeValidation()
      this.$track(this.$analyticsEvents.BLOOD_PRESSURE_UNKNOWN_SELECTED, {
        component: 'BloodPressure',
        panel_name: this.panelName,
        auto_progressed: this.autoProgress
      })
      
      if (this.autoProgress) {
        this.next()
      }
    },
    update() {
      this.items[0].unknown = false
      this.items[0].selected = false
      this.items[0].value = null
      if (!this.valid(this.systolic) || !this.valid(this.diastolic)) {
        this.clearRangeValidation()
        return
      }
      const value = `${this.systolic}/${this.diastolic}`
      const validation = this.validateBloodPressureRange(value)
      const accepted = validation.severity !== 'blocking'
      this.items[0].value = accepted ? value : null
      this.items[0].selected = accepted
      this.$track(this.$analyticsEvents.BLOOD_PRESSURE_ENTERED, {
        component: 'BloodPressure',
        panel_name: this.panelName,
        systolic: parseInt(this.systolic),
        diastolic: parseInt(this.diastolic),
        is_out_of_range: validation.severity !== 'normal',
        systolic_range: this.options.systolic,
        diastolic_range: this.options.diastolic
      })
    },
    ...mapActions({ next: 'v4/navigate/next' })
  },
  created() {
    this.systolic = this.items[0].value ? this.items[0].value.split('/')[0] : null
    this.diastolic = this.items[0].value ? this.items[0].value.split('/')[1] : null
  },
}
</script>

<style scoped>
.v-text-field {
  font-size: 1.5em;
}

.v-text-field--placeholder {
  font-size: 1em;
}

::v-deep .custom-placeholder .v-text-field__slot input::placeholder {
  color: var(--primaryblue);
  opacity: 0.66;
}
</style>
